

// subscription

const widgetId = 'appstle_subscription_widget0';

function setupWidgetClick() {
  const widget = document.getElementById(widgetId);
  if (!widget) return;

  if (widget.dataset.copilotBound) return;
  widget.dataset.copilotBound = 'true';

  widget.addEventListener('click', function(e) {
    e.stopPropagation();
    widget.classList.toggle('active');
  });

  // Prevent closing when clicking inside the popup
  const popup = widget.querySelector('.appstle_subscription_wrapper');
  if (popup) {
    popup.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  }

  document.addEventListener('click', function() {
    widget.classList.remove('active');
  });
}

const observer = new MutationObserver(() => {
  setupWidgetClick();
});

observer.observe(document.body, { childList: true, subtree: true });

setupWidgetClick();